export function useMethods() {
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  return {
    sleep,
  };
}
